import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { getAddressToDisplay, getValue } from 'core/utils';
import { IVendorQuote } from 'quotes/types';

interface IProps {
  quote: IVendorQuote;
}

export const BillToInfo = ({ quote }: IProps) => {
  const { t } = useTranslation();

  return (
    <InfoCard
      title={t('titleBillTo')}
      items={[
        {
          label: getValue(quote, 'billToAddress.name') as string,
          value: getAddressToDisplay(quote?.billToAddress),
        },
      ]}
    />
  );
};
